var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0273438 14.6653V18.5239H3.888L15.2743 7.14355L11.4137 3.28492L0.0273438 14.6653ZM18.2599 4.15954C18.3554 4.06435 18.4311 3.95128 18.4827 3.8268C18.5344 3.70232 18.561 3.56888 18.561 3.43412C18.561 3.29936 18.5344 3.16592 18.4827 3.04144C18.4311 2.91696 18.3554 2.80389 18.2599 2.7087L15.8509 0.300915C15.7556 0.205526 15.6425 0.129848 15.518 0.0782132C15.3934 0.0265782 15.2599 0 15.1251 0C14.9902 0 14.8567 0.0265782 14.7322 0.0782132C14.6076 0.129848 14.4945 0.205526 14.3993 0.300915L12.5153 2.18392L16.3759 6.04255L18.2599 4.15954Z",
    fill: "#F9FCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4bf36e8fbe7e64aec1723d9aeaecee52.svg";
export { ForwardRef as ReactComponent };